require("./../app.js");
require("./../components/cblPromotorMask/cblPromotorMaskSrvc.js");
require("./../components/cblPromotorMask/cblPromotorMaskCtrl.js");
